import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { returnsApi, type ReturnRequest } from '../../api/returns';

export function ReturnsListPage() {
  const [items, setItems] = useState<ReturnRequest[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void returnsApi.listReturns().then(setItems);
  }, []);

  async function createAndApprove() {
    const ret = await returnsApi.createReturn({
      order_id: `ORD-${Date.now()}`, reason_code: 'defective',
      items: [{ product_id: 'p1', quantity: 1, unit_price: 999 }],
    });
    await returnsApi.approveReturn(ret.id);
    setMsg(`Approved ${ret.return_number}`);
    setItems(await returnsApi.listReturns());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/returns" className="text-sm text-slate-600 hover:underline">← Returns hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Returns manager</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void createAndApprove()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Create & approve return</button>
      <ul className="mt-6 space-y-2">
        {items.map((r) => (
          <li key={r.id} className="rounded border p-3 text-sm">
            {r.return_number} — {r.status} · ₹{r.refund_amount} · health {(r.health_score * 100).toFixed(0)}%
          </li>
        ))}
      </ul>
    </div>
  );
}
